import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const MessagingInsights = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = true,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="messaging-insights-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7148 12.5947C19.0077 12.8876 19.0077 13.3624 18.7148 13.6553L15.7383 16.6319C15.7382 16.632 15.7383 16.6319 15.7383 16.6319C15.6164 16.7538 15.4716 16.8507 15.3123 16.9166C15.153 16.9827 14.9823 17.0166 14.8099 17.0166C14.6375 17.0166 14.4667 16.9827 14.3074 16.9166C14.1482 16.8507 14.0035 16.754 13.8817 16.6321C13.8816 16.632 13.8817 16.6321 13.8817 16.6321L12.5599 15.3103L9.71484 18.1553C9.42195 18.4482 8.94707 18.4482 8.65418 18.1553C8.36129 17.8624 8.36129 17.3876 8.65418 17.0947L11.6315 14.1173C11.6316 14.1173 11.6315 14.1174 11.6315 14.1173C11.7534 13.9955 11.8982 13.8986 12.0574 13.8326C12.2167 13.7666 12.3875 13.7326 12.5599 13.7326C12.7323 13.7326 12.9031 13.7666 13.0624 13.8326C13.2216 13.8986 13.3662 13.9953 13.4881 14.1172L14.8099 15.439L17.6542 12.5947C17.9471 12.3018 18.4219 12.3018 18.7148 12.5947Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.68451 5.0625C2.68451 3.75082 3.74783 2.6875 5.05951 2.6875H18.9345C20.2462 2.6875 21.3095 3.75082 21.3095 5.0625V18.9375C21.3095 20.2492 20.2462 21.3125 18.9345 21.3125H5.05951C3.74783 21.3125 2.68451 20.2492 2.68451 18.9375V5.0625ZM5.05951 4.4375C4.71433 4.4375 4.43451 4.71732 4.43451 5.0625V18.9375C4.43451 19.2827 4.71433 19.5625 5.05951 19.5625H18.9345C19.2797 19.5625 19.5595 19.2827 19.5595 18.9375V5.0625C19.5595 4.71732 19.2797 4.4375 18.9345 4.4375H5.05951Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.18446 5.0625C8.09044 5.0625 7.04123 5.4971 6.26764 6.27068C5.49405 7.04427 5.05946 8.09348 5.05946 9.1875C5.05946 10.2815 5.49405 11.3307 6.26764 12.1043C7.04123 12.8779 8.09044 13.3125 9.18446 13.3125C10.2764 13.3125 11.3236 12.8796 12.0968 12.1088C12.0983 12.1073 12.0998 12.1058 12.1013 12.1043C12.1028 12.1028 12.1043 12.1013 12.1057 12.0998C12.8765 11.3267 13.3095 10.2794 13.3095 9.1875C13.3095 8.09348 12.8749 7.04427 12.1013 6.27068C11.3277 5.4971 10.2785 5.0625 9.18446 5.0625ZM8.43446 6.67192C8.02042 6.79537 7.63935 7.0203 7.3283 7.33134C6.83602 7.82363 6.55946 8.49131 6.55946 9.1875C6.55946 9.88369 6.83602 10.5514 7.3283 11.0437C7.82059 11.5359 8.48827 11.8125 9.18446 11.8125C9.62434 11.8125 10.0528 11.7021 10.4329 11.4966L8.65413 9.71783C8.51347 9.57718 8.43446 9.38641 8.43446 9.1875V6.67192ZM11.4936 10.436L9.93446 8.87684V6.67192C10.3485 6.79537 10.7296 7.0203 11.0406 7.33134C11.5329 7.82363 11.8095 8.49131 11.8095 9.1875C11.8095 9.62739 11.699 10.0559 11.4936 10.436Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.622 6.9375C14.622 6.52329 14.9578 6.1875 15.372 6.1875H17.622C18.0362 6.1875 18.372 6.52329 18.372 6.9375C18.372 7.35171 18.0362 7.6875 17.622 7.6875H15.372C14.9578 7.6875 14.622 7.35171 14.622 6.9375Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.622 9.1875C14.622 8.77329 14.9578 8.4375 15.372 8.4375H17.622C18.0362 8.4375 18.372 8.77329 18.372 9.1875C18.372 9.60171 18.0362 9.9375 17.622 9.9375H15.372C14.9578 9.9375 14.622 9.60171 14.622 9.1875Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
